import tinyConfig from '../tinymce/config'

(() => {
  init()

  function init() {
    applyInputMask()
    applyFocusOnModal()
    applyWYSIWYGEditor()
    bindToggleClass()
    triggerOnload()
  }

  window.uniqid = function () {
    const date = new Date()

    return `${date.getFullYear()}${date.getMonth()}${date.getDate()}${date.getMinutes()}${date.getSeconds()}${date.getMilliseconds()}`
  }

  function applyFocusOnModal() {
    $('.modal').on('shown.bs.modal', function () {
      $(this).find('[autofocus]').focus()
    })
  }

  function applyInputMask() {
    $("[class~='date']").mask('99/99/9999')
    $("[class~='time']").mask('99:99:99')
    $("[class~='time-hm']").mask('99:99')
    $("[class~='datetime']").mask('99/99/9999 99:99:99')
    $("[class~='zipcode']").mask('99.999-999')
    $("[class~='cpf']").mask('999.999.999-99')
    $("[class~='cnpj']").mask('99.999.999/9999-99')
    $("[class~='percent']").mask('9?9')
    $("[class~='number']").mask("9", {reverse: true})
    $("[class~='phone']").mask("(99) 9999-9999")
    $("[class~='cellphone']").mask("(99) 9 9999-9999")
    $('[data-selected]').each(function () {
      $(this).find('option[value="' + $(this).attr('data-selected') + '"]').attr('selected', true)
    })
    $("[class~='coin']").maskMoney({
      decimal: ',',
      thousands: '',
      prefix: 'R$ ',
      affixesStay: false
    })

    $("[class~='grade']").maskMoney({
      decimal: '.',
      thousands: '',
      affixesStay: false,
      precision: 1
    })

    $("[class~='likemoney']").maskMoney({
      decimal: ',',
      thousands: '',
      affixesStay: false
    })

    $('.select2').select2({
      allowClear: true,
      placeholder: {
        id: 0,
        text: 'Selecione'
      },
      language: "pt-BR",
      width: '100%'

    })
    setupDateRangePicker()
  }

  function setupDateRangePicker() {
    let conf = {
      "opens": "left",
      "locale": {
        "format": "DD/MM/YYYY",
        "separator": " - ",
        "applyLabel": "Aplicar",
        "cancelLabel": "Cancelar",
        "fromLabel": "De",
        "toLabel": "Até",
        "customRangeLabel": "Personalizado",
        "weekLabel": "S",
        "daysOfWeek": [
          "D",
          "S",
          "T",
          "Q",
          "Q",
          "S",
          "S"
        ],
        "monthNames": [
          "Janeiro",
          "Fevereiro",
          "Março",
          "Abril",
          "Maio",
          "Junho",
          "Julho",
          "Agosto",
          "Setembro",
          "Outubro",
          "Novembro",
          "Dezembro"
        ],
        "firstDay": 1
      },
      ranges: {
        'Hoje': [moment(), moment()],
        'Ontem': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
        '7 dias': [moment().subtract(6, 'days'), moment()],
        '30 dias': [moment().subtract(29, 'days'), moment()],
        'Este mês': [moment().startOf('month'), moment().endOf('month')],
        'Último mês': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
      },
      startDate: moment().startOf('month'),
      endDate: moment().endOf('month'),
      showCustomRangeLabel: true,
      alwaysShowCalendars: true,
      buttonClasses: 'btn',
      applyClass: 'btn-success',
      cancelClass: 'btn-default'
    }
    $('.date-range').daterangepicker(conf)
  }

  function applyWYSIWYGEditor() {
    tinymce.init(tinyConfig)
  }

  function bindToggleClass() {
    $('.has-class-toggle').on('click', '[data-behavior="toggle-class"]', handleToggleClass)
  }

  function handleToggleClass() {
    let classes = $(this).data('class').split(',')
    $(this).toggleClass(classes[0]).toggleClass(classes[1])
  }

  function triggerOnload() {
    $('[data-triggeronload]').each(function (index, element) {
      element = $(element)
      let event = element.data('triggeronload')
      element.trigger(event)
    })
  }

  const btns = document.querySelectorAll(".submit-block-click")
  btns.forEach(btn => {
    btn.addEventListener("click", () => {
        const form = btn.closest('form')

        if (!form.checkValidity()) {
          return
        }

        btn.disabled = true
        btn.innerText = 'Enviando...'
        form.submit();
    })
  })
})()
